import { formatJS } from '@/app/lib/utils/string';
import CodepenIcon from '@/app/ui/assets/icons/codepen-icon';
import { Button } from '@/app/ui/components/atoms/button';
import { tailwindCSSHead } from '@/app/ui/components/molecules/component-preview/preview';

interface Props {
  title: string;
  content: string;
  js?: string;
  disabled?: boolean;
}

// https://blog.codepen.io/documentation/prefill/
export default function CodepenEdit({ title, content, js, disabled }: Props) {
  return (
    <form action='https://codepen.io/pen/define' method='POST' target='_blank' className='hidden lg:block'>
      <input
        type='hidden'
        name='data'
        value={JSON.stringify({
          title: `Tailframes UI Kit - ${title}`,
          html: content,
          js: js ? formatJS(js) : undefined,
          private: true,
          head: tailwindCSSHead,
        })}
      />
      <Button variant='text-default' size='small' type='submit' disabled={disabled} startAdornment={<CodepenIcon className='size-4' />}>
        Edit on CodePen
      </Button>
    </form>
  );
}
